export default {"src":"/_next/static/media/tour-guide.b7ff6e0d.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};